import {
  CHAPTER_VIEW_FIRST_ROW_SECTION_CAPACITY,
  CHAPTER_VIEW_MAX_SECTIONS_PER_ROW
} from '../constants'
import { ChapterViewSection } from '../types'

export type ChapterViewSectionRow = {
  sections: ChapterViewSection[]
  isFirstRow: boolean
}

export const packSectionRows = (
  sections: ChapterViewSection[] = []
): ChapterViewSectionRow[] => {
  if (sections.length === 0) {
    return []
  }

  const rows: ChapterViewSectionRow[] = []
  const firstRowCapacity = CHAPTER_VIEW_FIRST_ROW_SECTION_CAPACITY

  rows.push({
    sections: sections.slice(0, firstRowCapacity),
    isFirstRow: true
  })

  let index = firstRowCapacity

  while (index < sections.length) {
    rows.push({
      sections: sections.slice(
        index,
        index + CHAPTER_VIEW_MAX_SECTIONS_PER_ROW
      ),
      isFirstRow: false
    })
    index += CHAPTER_VIEW_MAX_SECTIONS_PER_ROW
  }

  return rows.filter(row => row.sections.length > 0)
}
